import React, { FC, useEffect, useState } from 'react';
import { Input } from 'antd';
import { InputProps } from 'antd/lib';

import { PlaceholderAsLabel } from '~shared/ui/layout';

interface ValidatedInputProps extends InputProps {
  uppercase?: boolean;
  clearSymbol?: boolean;
  trimSpaces?: boolean;
}

export const ValidatedInput: FC<ValidatedInputProps> = ({
  value: propValue,
  onChange,
  type,
  placeholder,
  uppercase,
  trimSpaces,
  clearSymbol,
  size = 'large',
  ...props
}) => {
  const [value, setValue] = useState<string | undefined>(propValue?.toString());

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = e.target.value;

    // Преобразуем в верхний регистр, если `uppercase` передан
    if (uppercase) {
      inputValue = inputValue.toUpperCase();
    }

    if (clearSymbol) {
      inputValue = inputValue.replace(/[^a-zA-Zа-яА-ЯёЁүөңһіҮӨҢҺІ\s\d]/g, '');
    }

    // Заменяем множественные пробелы на один
    if (trimSpaces) {
      inputValue = inputValue.replace(/\s+/g, ' ');
    }

    // Обновляем состояние
    setValue(inputValue);

    // Вызываем onChange, если он передан
    // @ts-ignore
    onChange?.(inputValue);
  };

  const handleBlur = () => {
    // Убираем пробелы в начале и в конце при потере фокуса
    if (value) {
      if (typeof value === 'string') {
        setValue(value.trim());
      }
    }
  };

  // Синхронизация внутреннего состояния с пропсом
  useEffect(() => {
    setValue(propValue?.toString());
  }, [propValue]);

  return (
    <PlaceholderAsLabel placeholder={placeholder} value={value}>
      <Input
        type={type}
        size={size}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        {...props}
      />
    </PlaceholderAsLabel>
  );
};
